import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Typography, Box, Divider, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from "react-router-dom";

const Answers = () => {
  const [answers, setAnswers] = useState([]);
  const [ispreRevnue, setIsPreRevenue] = useState(false);

  const location = useLocation();
  const { projectId, projectName } = location.state || {};

  const fetchQuestions = async () => {
    try {
      const resp = await axios.get(`/apiV1/project-qna/?project_id=${projectId}`);
      setIsPreRevenue(resp.data.is_pre_revenue);
      setAnswers(resp.data.qna || []);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  useEffect(() => {
    if (projectId) fetchQuestions();
  }, [projectId]);

  // Filter out question 11 if pre-revenue
  const filteredAnswers = answers.filter(item => !(item.question_id === 11 && ispreRevnue));

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
        <Link
          component={RouterLink}
          to="/dashboard"
          sx={{ color: "#71a2c0", textDecoration: "none", fontWeight: "bold" }}
        >
          Dashboard
        </Link>

        <Link
          component={RouterLink}
          to={`/documents?id=${projectId}&name=${projectName}`}
          sx={{ color: "#71a2c0", textDecoration: "none", fontWeight: "bold" }}
        >
          Documents
        </Link>

        <Typography sx={{ fontWeight: "bold" }}>Answers</Typography>
      </Breadcrumbs>

      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom align="center">
          Project Q&A
        </Typography>

        {filteredAnswers.length === 0 ? (
          <Typography align="center">Loading questions...</Typography>
        ) : (
          filteredAnswers.map((item, index) => (
            <Box key={item.question_id} mb={4}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                Question {index + 1}
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {item.question}
              </Typography>

              <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
                Answer
              </Typography>
              <Box
                sx={{
                  backgroundColor: '#f5f5f5',
                  padding: 2,
                  borderRadius: 1,
                  minHeight: '60px',
                  mb: 3
                }}
              >
                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                  {item.answer || 'No answer provided'}
                </Typography>
              </Box>

              {index < filteredAnswers.length - 1 && <Divider />}
            </Box>
          ))
        )}
      </Container>
    </>
  );
};

export default Answers;
